"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidMonitorFilterColumns = exports.disallowedMonitorFilterColumns = void 0;
/** disallowedMonitorFilterColumns lists filter column ids barred from a monitor query; currently none. */
exports.disallowedMonitorFilterColumns = [];
/** getValidMonitorFilterColumns drops columns whose `id` is in
 * `disallowedMonitorFilterColumns`. */
const getValidMonitorFilterColumns = (columns) => columns.filter((c) => !exports.disallowedMonitorFilterColumns.includes(c.id));
exports.getValidMonitorFilterColumns = getValidMonitorFilterColumns;
